module.exports = __webpack_public_path__ + "img/invesnow-logo-blue.66c33ded.svg";